export const categoryLabels = {
  RU: {
    'Series 1': '1 серия',
    'Series 2': '2 серия',
    'Series 3': '3 серия',
    'Series 4': '4 серия',
    'Series 5': '5 серия',
    'Not Available': 'Другое',
    None: 'Отсутствует в игре',
    Available: 'Присутствует в игре',
    'Recruit Season': 'Сезон рекрута',
    'Season Pass': 'Сезонный пропуск',
    'Starter Card': 'Стартовый набор',
    'Collection Level 1-14': 'Уровень Коллекции 1-14',
    Activate: 'Активация',
    Destroy: 'Уничтожение',
    Discard: 'Сброс',
    Move: 'Перемещение',
    'No Ability': 'Без способностей',
    'On Reveal': 'При раскрытии',
    Ongoing: 'Постоянно',
    'Game Start': 'В начале матча',
    'Start of Game': 'В начале игры',
    'End of Turn': 'В конце хода',
    Skill: 'Навыки',
  },
  EN: {
    'Series 1': 'Series 1',
    'Series 2': 'Series 2',
    'Series 3': 'Series 3',
    'Series 4': 'Series 4',
    'Series 5': 'Series 5',
    'Not Available': 'Other',
    None: 'Unavailable',
    Available: 'Available',
    'Recruit Season': 'Recruit Season',
    'Season Pass': 'Season Pass',
    'Starter Card': 'Starter Card',
    'Collection Level 1-14': 'Collection Level 1-14',
    Activate: 'Activate',
    Destroy: 'Destroy',
    Discard: 'Discard',
    Move: 'Move',
    'No Ability': 'No Ability',
    'On Reveal': 'On Reveal',
    Ongoing: 'Ongoing',
    'Game Start': 'Game Start',
    'Start of Game': 'Start of Game',
    'End of Turn': 'End of Turn',
    Skill: 'Skills',
  },
}

export const rarityLabels = {
  RU: {
    common: 'Обычная',
    uncommon: 'Необычная',
    rare: 'Редкая',
    'ultra-rare': 'Супер редкая',
  },
  EN: {
    common: 'Common',
    uncommon: 'Uncommon',
    rare: 'Rare',
    'ultra-rare': 'Ultra Rare',
  },
}

export const statusLabels = {
  RU: {
    released: 'Присутствует в игре',
    unreleased: 'Отсутствует в игре',
  },
  EN: {
    released: 'Available',
    unreleased: 'Unavailable',
  },
}

export const articleTypeLabels = {
  RU: {
    Guide: 'Гайды',
    Preview: 'Превью карт',
    Opinion: 'Мнения игроков о карте',
    Season: 'Сезоны',
    Patch: 'Патчи',
    OTA: 'OTA',
    Spotlight: 'Спотлайты',
    QA: 'Вопросы/Ответы',
    Mode: 'Режимы',
    SeriesDrop: 'Смена серии карт',
    News: 'Новости',
    Other: 'Другое',
  },
  EN: {
    Guide: 'Guides',
    Preview: 'Card previews',
    Opinion: 'Player opinions about card',
    Season: 'Seasons',
    Patch: 'Patches',
    OTA: 'OTA',
    Spotlight: 'Spotlights',
    QA: 'Questions/Answers',
    Mode: 'Modes',
    SeriesDrop: 'Series Drop',
    News: 'News',
    Other: 'Other',
  },
}

export const translations = {
  RU: {
    title: 'MARVEL SNAP',
    subtitle: 'Карты, локации, титулы и статьи (RU)',
    forumLink: 'Telegram: t.me/marvelsnapcom',
    tabs: {
      cards: 'Карты',
      locations: 'Локации',
      titles: 'Титулы',
      bingo: 'Бинго',
      articles: 'Статьи',
      editor: 'Редактор',
    },
    filters: {
      byCost: 'Стоимости',
      byPower: 'Силе',
      byRarity: 'Редкости',
      byDate: 'Дате',
      filtersTitle: 'Фильтры',
      tags: 'Теги:',
      sort: 'Сортировать по:',
      name: 'Имени',
      cost: 'Стоимость:',
      power: 'Сила:',
      asc: 'По возрастанию',
      desc: 'По убыванию',
      reset: 'Сбросить всё',
      shown: 'Показано',
      available: 'Присутствует в игре',
      unavailable: 'Отсутствует в игре',
      byArticleType: 'Типу статьи',
    },
    searchPlaceholder: 'Поиск...',
    share: 'Поделиться',
    copied: 'Скопировано',
    metaDescription: {
      cards:
        'Список карт Marvel Snap с описанием и характеристиками на русском языке.',
      locations: 'Локации Marvel Snap: описание и редкость на русском языке.',
      titles: 'Титулы игроков Marvel Snap на русском языке.',
      articles: 'Статьи о Marvel Snap: мнения игроков, превью карт и другое.',
    },
    metaKeywords: {
      cards:
        'Marvel Snap карты, карты игры, характеристики карт, названия карт, описания карт',
      locations:
        'Marvel Snap локации, редкость локаций, названия локаций, описания локаций',
      titles: 'Marvel Snap титулы, титулы игроков',
      articles: 'Marvel Snap статьи, мнения игроков, превью карт',
    },
  },
  EN: {
    title: 'MARVEL SNAP',
    subtitle: 'Cards, Locations and Titles (EN)',
    forumLink: 'Telegram: t.me/marvelsnapcom',
    tabs: {
      cards: 'Cards',
      locations: 'Locations',
      titles: 'Titles',
      bingo: 'Bingo',
      articles: 'Articles (RU)',
      editor: 'Editor',
    },
    filters: {
      byCost: 'Cost',
      byPower: 'Power',
      byRarity: 'Rarity',
      byDate: 'Date',
      filtersTitle: 'Filters',
      tags: 'Tags:',
      sort: 'Sort by:',
      name: 'Name',
      cost: 'Cost:',
      power: 'Power:',
      asc: 'Ascending',
      desc: 'Descending',
      reset: 'Reset All',
      shown: 'Shown',
      available: 'Available in game',
      unavailable: 'Not available',
      byArticleType: 'Article Type',
    },
    searchPlaceholder: 'Search...',
    share: 'Share',
    copied: 'Copied',
    metaDescription: {
      cards:
        'List of Marvel Snap cards with descriptions and stats in English.',
      locations: 'Marvel Snap locations: descriptions and rarity in English.',
      titles: 'Marvel Snap player titles in English.',
      articles:
        'Articles about Marvel Snap: player opinions, card previews, and more.',
    },
    metaKeywords: {
      cards:
        'Marvel Snap cards, game cards, card stats, card names, card descriptions',
      locations:
        'Marvel Snap locations, location rarity, location names, location descriptions',
      titles: 'Marvel Snap titles, player titles',
      articles: 'Marvel Snap articles, player opinions, card previews',
    },
  },
}

export default translations
